import { Component, Input, inject } from '@angular/core';
import { MatCardContent, MatCardModule } from "@angular/material/card";
import { MatDialog } from '@angular/material/dialog';
import { FlowItemModel, FlowItemViewModel } from '../../../shared/models/FlowItemModel';
import { GradesDisplayDialogComponent } from '../../../game/screens/grades-display-dialog/grades-display-dialog.component';
import { RouterModule } from '@angular/router';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-game-grades-card',
  imports: [MatCardModule, MatCardContent, RouterModule, DatePipe],
  templateUrl: './game-grades-card.component.html',
  styleUrl: './game-grades-card.component.css',
})
export class GameGradesCardComponent {
  readonly dialog = inject(MatDialog);

  @Input() GamePlayerRanking: FlowItemModel;

  

  openGradeDetails(GameId: string, Team: string){
    const dialogRef = this.dialog.open(GradesDisplayDialogComponent, {
      data: { GameId: GameId,
        Team: Team
       },
       width: '100vw',
      maxWidth: '450px',
      height: '100vh',
      
       panelClass: 'side-dialog',
      position: {
        right: '0'
      },
      
    });

    dialogRef.afterClosed().subscribe(result => {
      // console.log('Dialog was closed', result);
    });
  }
}
